import { RouteComponentProps } from 'react-router-dom'

import {
  Rule,
  Rules,
} from 'lib/validation'

import { Marks as RangeSliderMarks } from './RangeSlider/types'

export enum Icon {
  pin = 'pin',
  dollarSign = 'dollarSign',
}

export interface BaseProps {
  additionalQuoteRequestFieldsToUpdate?: AdditionalQuoteRequestFieldsToUpdate,
  asyncValidate?: Function,
  asyncValidateDebounceMs?: number,
  autocapitalize?: Autocapitalize,
  defaultValue?: Value,
  direction?: string,
  disabled?: boolean,
  errorText?: string,
  icon?: Icon,
  id?: string,
  isRequired?: boolean,
  label?: string,
  loaded?: boolean,
  marks?: RangeSliderMarks,
  maxLength?: string,
  max?: number,
  min?: number,
  mutateValue?: Function,
  name?: string,
  onChange?: OnChange,
  onSelect?: Function,
  options?: Option[],
  outputLabel?: string,
  placeholder?: string,
  quoteRequest?: string,
  quoteRequestField?: string,
  renderOptions?: RenderOptions,
  required?: boolean,
  rules?: Rule | Rules,
  step?: number,
  storeGeocodeTo?: string,
  type?: Type,
  uppercase?: boolean,
  valid?: boolean,
  value?: Value,
}

export interface FinalFormInput {
  onChange(event: React.ChangeEvent<HTMLInputElement>, ...options: unknown[]): void,
}

export type OnChange = (value: Value, ...options: unknown[]) => void

export type Option = string | [string, string] | object | any // eslint-disable-line @typescript-eslint/no-explicit-any

export type RenderOptions = (options: Option[]) => (React.ReactElement | undefined)[]

export enum Type {
  // Standard HTML input types
  address = 'address',
  color = 'color',
  date = 'date',
  datetime = 'datetime',
  email = 'email',
  month = 'month',
  number = 'number',
  password = 'password',
  range = 'range',
  search = 'search',
  tel = 'tel',
  text = 'text',
  time = 'time',
  url = 'url',
  week = 'week',

  // Additional types that we handle as Input
  checkbox = 'checkbox',
  radio = 'radio',
  rangeSlider = 'rangeSlider',
  select = 'select',
  textArea = 'textArea',
}

export enum Autocapitalize {
  characters = 'characters',
  none = 'none',
  sentences = 'sentences',
  words = 'words',
}

export interface Props extends BaseProps, RouteComponentProps{}

export type Value = string | number | boolean | object | Value[] | undefined

export type Label = string

export type AdditionalQuoteRequestFieldsToUpdate = string | string[] | object | Function
